import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles/common.styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
        ${common.fullContainer};
        display: flex;
        flex-direction: column;
    `,
        main: css`
        ${custom.dashBoardRoot};
        display: flex;
        flex-grow: 1;
        flex-direction: column;
    `,
        userLocationTitle: css`
        padding-bottom: 30px;
        align-self: baseline;
        width: 100%;
    `,
        userLocationText: css`
        border-bottom: 1px solid ${theme.palette.primary.main};
        color: ${theme.typography.h3.color};
    `,
        container: css`
        ${common.fullContainer};
        display: flex;
        flex-grow: 1;
        align-items: stretch;
        flex-direction: column;
        border-top: 1px solid ${theme.palette.secondary[50]};
    `,
        center: css`
        ${custom.border};
        display: flex;
        cursor: pointer;
        padding: 20px 40px;
        border-bottom: 1px solid ${theme.palette.secondary[50]};
        box-shadow: 1px 1px 1px #00000033;
    `,
        centerText: css`
        ${custom.messageText};
        font: normal normal normal 26px/32px Roboto;
    `,
    }
}

export default styles
